// Add this at the top of the file to inform the linter about window.edlio
/**
 * @typedef {Object} EdlioWindow
 * @property {boolean} isMobile
 * @property {number} [searchPage]
 * @property {string} [searchDomain]
 * @property {string} [districtId]
 * @property {string} [websiteId]
 * @property {Array<string|number>} [projectIds]
 */
// Use a local variable for edlio to avoid linter errors
var edlio = window.edlio;

// HTML elements global variables
var resultsList;
var searchBar;
var clearButton;
var searchBtn;
var paginationList;

var MAX_CONTENT_PREVIEW_LENGTH = 10;
var RESULTS_PER_PAGE = 10;

window.addEventListener("DOMContentLoaded", function(){
	resultsList = document.getElementById("results");
    searchBar = document.getElementById("search_bar");
    clearButton = document.getElementById("clear_button");
    searchBtn = document.getElementById("search_btn");
    paginationList = document.getElementById("pagination_container");

	main();
});

window.addEventListener('resize', function() {
    if(window.innerWidth <= 600  && !edlio.isMobile) {
        edlio.isMobile = true;
        search(edlio.searchPage);
    } else if(window.innerWidth > 600  && edlio.isMobile) {
        edlio.isMobile = false;
        search(edlio.searchPage);
    }
});

function main() {
    searchBar.focus();
    var schoolId = getDistrictIdOrWebsiteId();
	var searchQueryParam = getSearchQueryFromUrlParams();
	edlio.isMobile = window.innerWidth <= 600;
    edlio.searchPage = 1;

	if (searchQueryParam) {
		searchBar.value = searchQueryParam;
		search(1);
		removeHidden("clear_button");
	}

    clearButton.addEventListener("click", clearResults);

    searchBtn.addEventListener("click", function() {
        search(1);
    });

    searchBar.addEventListener("keyup", function(e) {
        /* Enter KeyCode */
        if (e.keyCode === 13 ) {
            search(1);
        }

        this.value ? removeHidden("clear_button") : addHidden("clear_button");
    });
}

// if districtId has a value use it, otherwise use websiteId
function getDistrictIdOrWebsiteId() {
	var districtId = edlio.districtId;

	if (districtId && districtId != '0' && districtId != 0) {
		return districtId;
	}

    return edlio.websiteId;
}

// Hit Websearch API
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function search(page) {
    if (!searchBar.value) { 
        return searchBar.focus(); 
    }

    if (resultsList.childElementCount) { 
        addOpacity("search_content_body");
    } else { 
        resultsList.innerHTML = renderLoadingMessage();
    }

    const searchParams = new URLSearchParams({
        q: searchBar.value,
        offset: (page - 1) * RESULTS_PER_PAGE,
        boostWebsiteId: edlio.websiteId,
    });

    var projectIds = edlio.projectIds;
    if (projectIds && projectIds.length > 0) {
        searchParams.set('projectIds', projectIds)
    }

    var url = edlio.searchDomain + getDistrictIdOrWebsiteId() + '/search?' + searchParams.toString();
    edlio.searchPage = page;
    
    fetch(url)
        .then(function(response) {
            return response.json();
        })
        .then(throwIfNoSearchResults)
        .then(transformSearchResultItems)
        .then(function(body) {
            resultsList.innerHTML = body.items.map(function(item) {
                return renderSearchResult(item);
            }).reduce(function(acc, el) {
                return acc + el;
            }, "");
    
            var resultsCount = body.pagination.count;
            showResultsCount(resultsCount);
            removeOpacity("search_content_body");
            renderPagination(resultsCount, page);
        })
        .catch(function(err) {
			addHidden("count_container");
			addHidden("pagination_container");
			removeOpacity("search_content_body");
            renderNoResults();
        });
};

function transformSearchResultItems(body) {
    body.items.forEach(function(item) {
        if (item._source.WebsiteID == "DEFAULT") {
            item._source.Url = window.location.origin + item._source.Url.replace(/^.*\/\/[^\/]+/, '');
        }
    });

    return body;
}

function throwIfNoSearchResults(body) {
    if (body.items.length === 0) {
        throw new Error("No results found");
    }

    return body;
}

function getSearchQueryFromUrlParams(url) {
	const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);

    return searchParams.get('q');
}

// Rendering
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function renderSearchResult(item) {
    var bodySourceUrl = item._source.Url;
    var title = item._source.Title || item.highlight.Title[0];

    var resultBody = "";

    if (item._source.PreviewText && item._source.PreviewText.length) {
        resultBody = item._source.PreviewText;
    } else if (item.highlight && item.highlight.Text && item.highlight.Text.length) {
        item.highlight.Text.forEach(function(mention, index) {
            resultBody += mention.trim();

            if (index !== item.highlight.Text.length - 1) {
                resultBody += "...";
            }
        })
    } else {
        resultBody = item._source.Text ? getResultText(item._source.Text) : "";
    }

    var innerHTML = "<div class='result-item'>"
                  + "<div class='result-title'>"
                  + "<a href='" + bodySourceUrl + "'>" + title + "</a>"
                  + "</div>"
                  + "<div class=\"result-link\">"
                  + "<a href=" + bodySourceUrl + ">" + bodySourceUrl + "</a>"
                  + "</div>"
                  + "<div class=\"result-preview\">"
                  + resultBody
                  + "</div>"
                  + "</div>"

    return innerHTML;
}

function getResultText(rawText) {
	var text = "";

	//todo: this strips out marks - put them back in after? Too expensive to do that?
	text = stripTags(rawText);
	var firstSentence = text.split(".")[0];

	if (firstSentence.split(" ").length < MAX_CONTENT_PREVIEW_LENGTH) {
		text = firstSentence;
	} else {
		text = firstSentence.split(" ").slice(0,MAX_CONTENT_PREVIEW_LENGTH).join(" ");
		text += "&#8230";
	}
	return text;
}

function showResultsCount(resultsCount) {
	removeHidden("count_container");
	removeHidden("pagination_container");

    var resultsCountEl = document.getElementById("search_results_count_text");
    resultsCountEl.innerText = resultsCount.toString() + ' results';
    resultsCountEl.setAttribute('aria-live', 'polite');
}

function renderNoResults() {
    removeChildNodes(resultsList);
    var containerEl = document.createElement('p');
    containerEl.className = 'no-results';
    containerEl.innerHTML = 'No Results';
    containerEl.setAttribute('aria-live', 'polite');

    resultsList.appendChild(containerEl);
}

function renderLoadingMessage() { 
    return "<div class='loading'>Searching...</div>"; 
}

// Pagination
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function renderPagination(resultsCount, page) {
    var pageCount = Math.ceil(resultsCount / RESULTS_PER_PAGE);
    renderCustomPagination({
        currentPage: page,
        totalPages: pageCount,
        onPageChange: function(newPage) { search(newPage); },
        containerId: 'pagination_container'
    });
}

function PaginationButton(params) {
    var buttonEl = document.createElement('button');
    buttonEl.className = 'pagination-button';

    if (params.current) {
        buttonEl.classList.add("current-page");
    }

    buttonEl.textContent = params.pageNumber;
    buttonEl.addEventListener('click', params.onClick);

    return buttonEl;
}

// Misc
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function addHidden(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.add("hidden");
}

function removeHidden(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.remove("hidden");
}

function addOpacity(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.add("opaque");
}

function removeOpacity(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.remove("opaque");
}

function clearResults() {
    removeChildNodes(resultsList);
    searchBar.value = "";
	addHidden("clear_button");
	addHidden("count_container");
	addHidden("pagination_container");
}

function removeChildNodes(parentEl) {
    while (parentEl.firstChild) {
        parentEl.removeChild(parentEl.firstChild);
    }
}

function stripTags(html){
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
}

function renderCustomPagination({ currentPage, totalPages, onPageChange, containerId }) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';

    // Responsive: 10 pages for desktop/tablet, 5 for mobile
    const isMobile = edlio.isMobile;
    const maxPages = isMobile ? 5 : 10;

    // Helper: Create a button
    function createBtn(label, page, opts = {}) {
        const btn = document.createElement('button');
        btn.textContent = label;
        btn.className = 'pagination-btn';
        if (opts.active) btn.classList.add('active');
        if (opts.ellipsis) btn.classList.add('ellipsis');
        if (opts.arrow) btn.innerHTML = `<span class="arrow">${label}</span>`;
        if (opts.disabled) btn.disabled = true;
        if (opts.skip) btn.style.borderRadius = '4px';
        // Default: no margin, no border radius
        btn.style.margin = '0';
        btn.style.padding = '8px 18px';
        btn.style.fontSize = '1.1em';
        btn.style.border = '1px solid #ccc';
        btn.style.cursor = opts.disabled ? 'default' : 'pointer';
        btn.onclick = function() {
            if (!opts.disabled && page !== currentPage) onPageChange(page);
        };
        return btn;
    }

    // Helper: Ellipsis
    function createEllipsis() {
        const span = document.createElement('span');
        span.textContent = '...';
        span.className = 'pagination-btn ellipsis';
        span.style.display = 'inline-block';
        span.style.fontSize = '1.1em';
        span.style.background = 'transparent';
        span.style.textDecoration = 'none';
        span.style.verticalAlign = 'middle';
        span.style.textAlign = 'center';
        return span;
    }

    // Collect buttons for main group (for border radius logic)
    const mainBtns = [];

    // Calculate start/end page
    let start = 1, end = totalPages;
    if (totalPages > maxPages) {
        if (currentPage <= Math.ceil(maxPages / 2)) {
            start = 1;
            end = maxPages;
        } else if (currentPage > totalPages - Math.floor(maxPages / 2)) {
            start = totalPages - maxPages + 1;
            end = totalPages;
        } else {
            start = currentPage - Math.floor(maxPages / 2);
            end = start + maxPages - 1;
        }
    }

    // Skip 10 left (desktop/tablet)
    if (!isMobile && currentPage > 10) {
        const skipLeft = createBtn('«10', currentPage - 10, {skip: true});
        skipLeft.style.marginRight = '8px';
        skipLeft.setAttribute('aria-label', 'Go to Page ' + (currentPage - 10));
        container.appendChild(skipLeft);
    }

    // Prev arrow
    var leftArrow = createBtn('‹', Math.max(1, currentPage - 1), { disabled: currentPage === 1, arrow: true });
    leftArrow.setAttribute('aria-label', 'Go to Previous Page');
    mainBtns.push(leftArrow);

    // First page + ellipsis
    if (start > 1) {
        mainBtns.push(createBtn('1', 1));
        if (start > 2) mainBtns.push(createEllipsis());
    }

    // Numbered buttons
    for (let i = start; i <= end; i++) {
        mainBtns.push(createBtn(i, i, { active: i === currentPage }));
    }

    // Last page + ellipsis
    if (end < totalPages) {
        if (end < totalPages - 1) mainBtns.push(createEllipsis());
        mainBtns.push(createBtn(totalPages, totalPages));
    }

    // Next arrow
    var rightArrow = createBtn('›', Math.min(totalPages, currentPage + 1), { disabled: currentPage === totalPages, arrow: true });
    rightArrow.setAttribute('aria-label', 'Go to Next Page');
    mainBtns.push(rightArrow);

    // Apply border radius to first and last mainBtns
    if (mainBtns.length > 0) {
        mainBtns[0].style.borderTopLeftRadius = '8px';
        mainBtns[0].style.borderBottomLeftRadius = '8px';
        mainBtns[mainBtns.length - 1].style.borderTopRightRadius = '8px';
        mainBtns[mainBtns.length - 1].style.borderBottomRightRadius = '8px';
    }

    // Append mainBtns to container
    mainBtns.forEach(btn => container.appendChild(btn));

    // Skip 10 right (desktop/tablet)
    if (!isMobile && currentPage <= totalPages - 10) {
        const skipRight = createBtn('10»', currentPage + 10, {skip: true});
        skipRight.style.marginLeft = '8px';
        skipRight.setAttribute('aria-label', 'Go to Page ' + (currentPage + 10));
        container.appendChild(skipRight);
    }
}